import { render, staticRenderFns } from "./EmptyAgencyApplicationView.vue?vue&type=template&id=850ba1c8&scoped=true&"
import script from "./EmptyAgencyApplicationView.vue?vue&type=script&lang=js&"
export * from "./EmptyAgencyApplicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850ba1c8",
  null
  
)

export default component.exports